import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgIcPhone = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "521.974 240.603 8.75 12.432",
	fill: "currentColor",
	...props,
	children: /* @__PURE__ */ _jsx("path", { d: " M 527.208 249.806 C 527.622 249.673 528.876 248.444 529.558 249.279 C 530.459 250.382 531.193 251.773 530.357 252.594 C 529.921 253.023 529.035 253.071 528.289 253.019 C 527.416 252.958 526.58 252.641 525.885 252.109 C 522.531 249.54 522.008 244.792 522.008 244.792 L 522.03 244.825 C 521.892 243.96 522.009 243.075 522.371 242.277 C 522.679 241.596 523.142 240.839 523.727 240.659 C 524.846 240.313 525.655 241.649 526.265 242.936 C 526.561 243.559 526.672 244.243 524.685 244.754 C 524.685 244.754 524.624 245.917 525.298 247.442 C 525.973 248.967 527.207 249.806 527.208 249.806 Z " })
});
export default SvgIcPhone;
